'use client';

import { useContext } from 'react';
import { CalendarContext } from "../CalendarProvider.js";
export var useCalendar = function useCalendar() {
  return useContext(CalendarContext);
};